import type {LinkField, RichTextField} from '@prismicio/client'
import {PrismicRichText} from '@prismicio/react'
import type {
  BlogPostSliceDefaultPrimaryBannerItem,
  BlogPostSliceDefaultPrimaryFaqSectionItem,
  BlogPostSliceDefaultPrimaryListSectionItem,
  BlogPostSliceDefaultPrimaryTableItem,
  BlogPostSliceDefaultPrimaryTakeawaysSectionItem,
  ButtonDocument,
} from 'prismicio-types'
import type {FC} from 'react'
import {richTextComponents} from '../config/richTextComponents'
import type {ParagraphNode, QuoteItem} from './ParagraphComponent'
import {ParagraphComponent} from './ParagraphComponent'

type ArticleContentProps = {
  content: RichTextField
  sections: {
    takeaways: BlogPostSliceDefaultPrimaryTakeawaysSectionItem[]
    list: BlogPostSliceDefaultPrimaryListSectionItem[]
    banner: BlogPostSliceDefaultPrimaryBannerItem[]
    faq: BlogPostSliceDefaultPrimaryFaqSectionItem[]
    table: BlogPostSliceDefaultPrimaryTableItem[]
    skillDownloadLink?: LinkField
    chatgptPromptDownloadLink?: LinkField
    githubRepositoryLink?: LinkField
    quotes?: QuoteItem[]
  }
  buttonsData?: ButtonDocument[]
}

/**
 * Article main content with rich text rendering
 */
export const ArticleContent: FC<ArticleContentProps> = ({content, sections, buttonsData}) => (
  <PrismicRichText
    field={content}
    components={{
      ...richTextComponents,
      paragraph: ({children, node}) => (
        <ParagraphComponent sections={sections} node={node as ParagraphNode} buttonsData={buttonsData}>
          {children}
        </ParagraphComponent>
      ),
    }}
  />
)
